/* Home composition: sourced hero scenarios, gallery and deferred computer engine. */
(() => {
'use strict';
/* Shared computer playback is owned by ow-ai-computer.js. */
function init(root) {
  root.querySelectorAll('[data-home-industry]').forEach(select => {
    if (select.dataset.ready) return; select.dataset.ready = 'true';
    select.closest('[data-home-filter-wrap]').hidden = false;
    const cards = [...root.querySelectorAll('[data-home-case]')];
    select.addEventListener('change', () => {
      let shown = 0;
      cards.forEach((card, index) => {
        const match = select.value === 'all' ? index < 6 : card.dataset.homeCase === select.value || card.dataset.homeCase === 'any';
        card.hidden = !match; if (match) shown++;
      });
      root.querySelector('[data-home-case-count]').textContent = shown + ' use cases';
    });
  });
  root.querySelectorAll('[data-demo-src]').forEach(demo => {
    if (demo.dataset.loading) return;
    let loaded = false;
    const pending = [];
    demo.addEventListener('click', event => {
      if (demo.__player) return;
      const button = event.target.closest('button');
      if (!button || !demo.contains(button)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      pending.push(button); load();
    }, true);
    demo.addEventListener('home:demo-ready', () => {
      const replay = () => {
        const button = pending.shift();
        if (!button) return;
        if (button.isConnected && !button.disabled) button.click();
        if (pending.length) setTimeout(replay, 220);
      };
      replay();
    }, {once: true});
    const load = () => {
      if (loaded) return; loaded = true; demo.dataset.loading = 'true';
      if (window.OW_initHomeDemo) return window.OW_initHomeDemo(demo);
      const script = document.createElement('script'); script.src = demo.dataset.demoSrc; script.async = true;
      script.onerror = () => { loaded = false; delete demo.dataset.loading; script.remove(); };
      document.head.appendChild(script);
    };
    // Focus or pointer input initializes immediately if a visitor jumps to a control.
    demo.addEventListener('focusin', load, {once: true});
    demo.addEventListener('pointerenter', load, {once: true});
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); load(); } }, {rootMargin:'400px 0px'});
      io.observe(demo);
      document.addEventListener('shopify:section:unload', function unload(e) {if(e.target.contains(demo)){io.disconnect();document.removeEventListener('shopify:section:unload',unload);}});
    } else load();
  });
}
init(document);
document.addEventListener('shopify:section:load', e => init(e.target));
})();
